import { InputHTMLAttributes, ReactNode } from 'react';

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'children'> {
  label?: string;
  error?: string;
  hint?: string;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  fullWidth?: boolean;
}

export default function Input({
  label,
  error,
  hint,
  leftIcon,
  rightIcon,
  fullWidth = true,
  className = '',
  ...props
}: InputProps) {
  return (
    <div className={fullWidth ? 'w-full' : ''}>
      {label && (
        <label className="block text-sm font-medium text-[var(--color-gray-700)] mb-1.5">
          {label}
          {props.required && <span className="text-[var(--color-error)] ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--color-gray-400)]">
            {leftIcon}
          </div>
        )}
        <input
          className={`
            w-full border rounded-[var(--radius-md)] 
            px-3 py-2.5 text-[var(--color-gray-800)]
            placeholder:text-[var(--color-gray-400)]
            transition-all duration-[var(--transition-fast)]
            focus:outline-none focus:ring-2
            ${error
              ? 'border-[var(--color-error)] focus:ring-[var(--color-error-light)]'
              : 'border-[var(--color-gray-300)] focus:ring-[var(--color-primary)] focus:border-[var(--color-primary)]'
            }
            ${leftIcon ? 'pl-10' : ''}
            ${rightIcon ? 'pr-10' : ''}
            ${className}
          `}
          {...props}
        />
        {rightIcon && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--color-gray-400)]">
            {rightIcon}
          </div>
        )}
      </div>
      {error && (
        <p className="mt-1.5 text-xs text-[var(--color-error)]">{error}</p>
      )}
      {hint && !error && (
        <p className="mt-1.5 text-xs text-[var(--color-gray-500)]">{hint}</p>
      )}
    </div>
  );
}